/* eslint-disable import/no-cycle */
import Api from '../helpers/api';

async function getVersion() {
  let localStoredVersion = sessionStorage.getItem('version');

  if (localStoredVersion === null) {
    try {
      const res = await Api.get('/version');
      sessionStorage.setItem('version', res.version);
      localStoredVersion = res.version;
    } catch (err) {
      console.error(err);
    }
  }

  return localStoredVersion;
}

export const versionService = {
  getVersion,
};
